// extracted by mini-css-extract-plugin
export default {"loading":"LoadingBlock_loading__yN0Oo"};